module.exports = __webpack_public_path__ + "img/banner_half.6e2471ce.jpg";